<div id="header" class="header-default">
  <div class="px_15 lg-px_40">
      <div class="row wrapper-header align-items-center">
          <div class="col-md-4 col-3 tf-lg-hidden">
              <a href="#mobileMenu" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16"
                      fill="none">
                      <path
                          d="M2.00056 2.28571H16.8577C17.1608 2.28571 17.4515 2.16531 17.6658 1.95098C17.8802 1.73665 18.0006 1.44596 18.0006 1.14286C18.0006 0.839753 17.8802 0.549063 17.6658 0.334735C17.4515 0.120408 17.1608 0 16.8577 0H2.00056C1.69745 0 1.40676 0.120408 1.19244 0.334735C0.978109 0.549063 0.857702 0.839753 0.857702 1.14286C0.857702 1.44596 0.978109 1.73665 1.19244 1.95098C1.40676 2.16531 1.69745 2.28571 2.00056 2.28571ZM0.857702 8C0.857702 7.6969 0.978109 7.40621 1.19244 7.19188C1.40676 6.97755 1.69745 6.85714 2.00056 6.85714H22.572C22.8751 6.85714 23.1658 6.97755 23.3801 7.19188C23.5944 7.40621 23.7148 7.6969 23.7148 8C23.7148 8.30311 23.5944 8.59379 23.3801 8.80812C23.1658 9.02245 22.8751 9.14286 22.572 9.14286H2.00056C1.69745 9.14286 1.40676 9.02245 1.19244 8.80812C0.978109 8.59379 0.857702 8.30311 0.857702 8ZM0.857702 14.8571C0.857702 14.554 0.978109 14.2633 1.19244 14.049C1.40676 13.8347 1.69745 13.7143 2.00056 13.7143H12.2863C12.5894 13.7143 12.8801 13.8347 13.0944 14.049C13.3087 14.2633 13.4291 14.554 13.4291 14.8571C13.4291 15.1602 13.3087 15.4509 13.0944 15.6653C12.8801 15.8796 12.5894 16 12.2863 16H2.00056C1.69745 16 1.40676 15.8796 1.19244 15.6653C0.978109 15.4509 0.857702 15.1602 0.857702 14.8571Z"
                          fill="currentColor"></path>
                  </svg>
              </a>
          </div>
          <div class="col-xl-3 col-md-4 col-6">
              <a href="/home" class="logo-header">
                  <img src="assets/images/logo.png" alt="" class="logo">
              </a>
          </div>
          <div class="col-xl-6 tf-md-hidden">
              <nav class="box-navigation text-center">
                  <ul class="box-nav-ul d-flex align-items-center justify-content-center gap-30">
                      <li class="menu-item">
                          <a href="/home" class="item-link">Accueil</a>

                      </li>
                      <li class="menu-item position-relative">
                        <a href="#" class="item-link">Boutique</a>
                        <div class="sub-menu submenu-default">
                          <ul class="menu-list">
                            <li *ngFor="let category of listCategory" class="menu-item-2">
                              <a (click)="navigateToCategory(category)" class="menu-link-text link text_black-2">{{ category.libelle }}</a>

                              <div *ngIf="category.sous_categories?.length > 0" class="sub-menu submenu-default">
                                <ul class="menu-list">
                                  <li *ngFor="let sub of category.sous_categories">
                                    <a (click)="navigateToSubCategory(sub.id)" class="menu-link-text link text_black-2">
                                      {{ sub.libelle }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li class="menu-item">
                          <a href="/contact" class="item-link">Contact</a>

                      </li>
                      <!-- <li class="menu-item position-relative">
                          <a href="#" class="item-link">Pages<i class="icon icon-arrow-down"></i></a>
                          <div class="sub-menu submenu-default">
                              <ul class="menu-list">
                                  <li>
                                      <a href="about-us.html" class="menu-link-text link text_black-2">About
                                          us</a>
                                  </li>
                                  <li class="menu-item-2">
                                      <a href="#" class="menu-link-text link text_black-2">Brands</a>
                                      <div class="sub-menu submenu-default">
                                          <ul class="menu-list">
                                              <li>
                                                  <a href="brands.html"
                                                      class="menu-link-text link text_black-2 position-relative">Brands
                                                      <div class="demo-label"><span
                                                              class="demo-new">New</span></div>
                                                  </a>
                                              </li>
                                              <li><a href="brands-v2.html"
                                                      class="menu-link-text link text_black-2">Brand V2</a>
                                              </li>
                                          </ul>
                                      </div>
                                  </li>
                                  <li class="menu-item-2">
                                      <a href="#" class="menu-link-text link text_black-2">Contact</a>
                                      <div class="sub-menu submenu-default">
                                          <ul class="menu-list">
                                              <li><a href="contact-1.html"
                                                      class="menu-link-text link text_black-2">Contact 1</a>
                                              </li>
                                              <li><a href="contact-2.html"
                                                      class="menu-link-text link text_black-2">Contact 2</a>
                                              </li>
                                          </ul>
                                      </div>
                                  </li>
                                  <li class="menu-item-2">
                                      <a href="#" class="menu-link-text link text_black-2">FAQ</a>
                                      <div class="sub-menu submenu-default">
                                          <ul class="menu-list">
                                              <li><a href="faq-1.html"
                                                      class="menu-link-text link text_black-2">FAQ 01</a></li>
                                              <li><a href="faq-2.html"
                                                      class="menu-link-text link text_black-2">FAQ 02</a></li>
                                          </ul>
                                      </div>
                                  </li>
                                  <li class="menu-item-2">
                                      <a href="#" class="menu-link-text link text_black-2">Store</a>
                                      <div class="sub-menu submenu-default">
                                          <ul class="menu-list">
                                              <li><a href="our-store.html"
                                                      class="menu-link-text link text_black-2">Our store</a>
                                              </li>
                                              <li><a href="store-locations.html"
                                                      class="menu-link-text link text_black-2">Store
                                                      locator</a></li>
                                          </ul>
                                      </div>
                                  </li>
                                  <li><a href="timeline.html"
                                          class="menu-link-text link text_black-2 position-relative">Timeline
                                          <div class="demo-label"><span class="demo-new">New</span></div>
                                      </a>
                                  </li>
                                  <li><a href="view-cart.html"
                                          class="menu-link-text link text_black-2 position-relative">View
                                          cart</a></li>
                                  <li><a href="checkout.html"
                                          class="menu-link-text link text_black-2 position-relative">Check
                                          out</a></li>
                                  <li class="menu-item-2">
                                      <a href="#" class="menu-link-text link text_black-2">Payment</a>
                                      <div class="sub-menu submenu-default">
                                          <ul class="menu-list">
                                              <li><a href="payment-confirmation.html"
                                                      class="menu-link-text link text_black-2">Payment
                                                      Confirmation</a></li>
                                              <li><a href="payment-failure.html"
                                                      class="menu-link-text link text_black-2">Payment
                                                      Failure</a></li>
                                          </ul>
                                      </div>
                                  </li>
                                  <li class="menu-item-2">
                                      <a href="#" class="menu-link-text link text_black-2">My account</a>
                                      <div class="sub-menu submenu-default">
                                          <ul class="menu-list">
                                              <li><a href="my-account.html"
                                                      class="menu-link-text link text_black-2">My account</a>
                                              </li>
                                              <li><a href="my-account-orders.html"
                                                      class="menu-link-text link text_black-2">My order</a>
                                              </li>
                                              <li><a href="my-account-orders-details.html"
                                                      class="menu-link-text link text_black-2">My order
                                                      details</a></li>
                                              <li><a href="my-account-address.html"
                                                      class="menu-link-text link text_black-2">My address</a>
                                              </li>
                                              <li><a href="my-account-edit.html"
                                                      class="menu-link-text link text_black-2">My account
                                                      details</a></li>
                                              <li><a href="my-account-wishlist.html"
                                                      class="menu-link-text link text_black-2">My wishlist</a>
                                              </li>
                                          </ul>
                                      </div>
                                  </li>
                                  <li><a href="invoice.html"
                                          class="menu-link-text link text_black-2 position-relative">Invoice</a>
                                  </li>
                                  <li><a href="404.html"
                                          class="menu-link-text link text_black-2 position-relative">404</a>
                                  </li>

                              </ul>
                          </div>
                      </li> -->
                      <li class="menu-item position-relative">
                          <a href="" class="item-link" (click)="goToAccount($event)">Mon Compte </a>

                      </li>
                      <li class="menu-item"><a
                              href="/checkout"
                              class="item-link">Commander</a></li>
                  </ul>
              </nav>
          </div>
          <div class="col-xl-3 col-md-4 col-3">
              <ul class="nav-icon d-flex justify-content-end align-items-center gap-20">
                  <li class="nav-search"><a href="#canvasSearch" data-bs-toggle="offcanvas"
                          aria-controls="offcanvasLeft" class="nav-icon-item"><i
                              class="icon icon-search"></i></a></li>
                  <li class="nav-account"><a (click)="goToAccount($event)" class="nav-icon-item"><i
                              class="icon icon-account"></i></a></li>
                  <li class="nav-wishlist"><a href="/wishlist" class="nav-icon-item"><i
                              class="icon icon-heart"></i><span class="count-box">{{ wishlistCount }}</span></a></li>
                  <li class="nav-cart"><a href="#shoppingCart" data-bs-toggle="modal" class="nav-icon-item"><i
                              class="icon icon-bag"></i><span class="count-box">{{ cartCount }}</span></a></li>
              </ul>
          </div>
      </div>
  </div>
 <div class="modal fullRight fade modal-shopping-cart" id="shoppingCart">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="header">
                <div class="title fw-5">Mon Panier <span>({{ cartCount }})</span></div>
                <span class="icon-close icon-close-popup" data-bs-dismiss="modal" style="cursor: pointer;"></span>
            </div>
            <div class="wrap">
                <!-- <div class="tf-mini-cart-threshold">
                    <div class="tf-progress-bar">
                        <span style="width: 50%;">
                            <div class="progress-car">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14"
                                    fill="currentColor">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M0 0.875C0 0.391751 0.391751 0 0.875 0H13.5625C14.0457 0 14.4375 0.391751 14.4375 0.875V3.0625H17.3125C17.5867 3.0625 17.845 3.19101 18.0104 3.40969L20.8229 7.12844C20.9378 7.2804 21 7.46572 21 7.65625V11.375C21 11.8582 20.6082 12.25 20.125 12.25H17.7881C17.4278 13.2695 16.4554 14 15.3125 14C14.1696 14 13.1972 13.2695 12.8369 12.25H7.72563C7.36527 13.2695 6.39293 14 5.25 14C4.10706 14 3.13473 13.2695 2.77437 12.25H0.875C0.391751 12.25 0 11.8582 0 11.375V0.875ZM2.77437 10.5C3.13473 9.48047 4.10706 8.75 5.25 8.75C6.39293 8.75 7.36527 9.48046 7.72563 10.5H12.6875V1.75H1.75V10.5H2.77437ZM14.4375 8.89937V4.8125H16.8772L19.25 7.94987V10.5H17.7881C17.4278 9.48046 16.4554 8.75 15.3125 8.75C15.0057 8.75 14.7112 8.80264 14.4375 8.89937ZM5.25 10.5C4.76676 10.5 4.375 10.8918 4.375 11.375C4.375 11.8582 4.76676 12.25 5.25 12.25C5.73323 12.25 6.125 11.8582 6.125 11.375C6.125 10.8918 5.73323 10.5 5.25 10.5ZM15.3125 10.5C14.8293 10.5 14.4375 10.8918 14.4375 11.375C14.4375 11.8582 14.8293 12.25 15.3125 12.25C15.7957 12.25 16.1875 11.8582 16.1875 11.375C16.1875 10.8918 15.7957 10.5 15.3125 10.5Z">
                                    </path>
                                </svg>
                            </div>
                        </span>
                    </div>
                    <div class="tf-progress-msg">
                      <div *ngIf="getRemainingForFreeShipping() > 0">
                        Buy <span class="price fw-6">{{ getRemainingForFreeShipping() | number:'1.3-3' }} DT</span> more to enjoy
                        <span class="fw-6">Free Shipping</span>
                      </div>
                      <div *ngIf="getRemainingForFreeShipping() === 0">
                        🎉 You’ve unlocked <span class="fw-6">Free Shipping!</span>
                      </div>

                    </div>
                </div> -->
                <div class="tf-mini-cart-wrap">
                    <div class="tf-mini-cart-main">
                        <div class="tf-mini-cart-sroll">
                            <div class="tf-mini-cart-items">
                                <div class="tf-mini-cart-item" *ngFor="let item of cartItems">
                                    <div class="tf-mini-cart-image">
                                        <a>
                                            <img  [src]="item.images[0]?.data" alt="">
                                        </a>
                                    </div>
                                    <div class="tf-mini-cart-info">
                                        <a class="title link">{{ item.libelle }}</a>
                                        <!-- <div class="meta-variant">Light gray</div> -->
                                        <div class="price fw-6">
                                          {{ (item.promo !== 0 ? item.prix_final : item.prix_ttc) | number:'1.3-3' }} DT
                                        </div>
                                        <div class="tf-mini-cart-btns">
                                          <div class="wg-quantity small">
                                            <span class="btn-quantity minus-btn" (click)="decreaseQuantity(article)" >-</span>
                                            <input type="text" [value]="item.quantity">
                                            <span class="btn-quantity plus-btn" (click)="increaseQuantity(article)" >+</span>
                                          </div>
                                            <!-- <div class="tf-mini-cart-remove">Supprimer</div> -->
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="tf-mini-cart-bottom">

                        <div class="tf-mini-cart-bottom-wrap">
                            <div class="tf-cart-totals-discounts">
                                <div class="tf-cart-total">Total</div>
                                <div class="tf-totals-total-value fw-6">
                                  {{ getCartTotal() | number:'1.3-3' }} DT
                                </div>
                            </div>

                            <div class="tf-mini-cart-line"></div>
                            <div class="tf-cart-checkbox">
                                <div class="tf-checkbox-wrapp">
                                    <input class="" type="checkbox" id="CartDrawer-Form_agree"
                                        name="agree_checkbox">
                                    <div>
                                        <i class="icon-check"></i>
                                    </div>
                                </div>
                                <label for="CartDrawer-Form_agree">
                                  J'accepte les
                                  <a title="Conditions d'utilisation">conditions générales</a>
                                </label>
                            </div>
                            <div class="tf-mini-cart-view-checkout">
                                <a (click)="goToCart()"
                                    class="tf-btn btn-outline radius-3 link w-100 justify-content-center">Voir panier
                                    </a>
                                <a (click)="goToCheckout()"
                                    class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Commander</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="tf-mini-cart-tool-openable add-note">
                        <div class="overplay tf-mini-cart-tool-close"></div>
                        <div class="tf-mini-cart-tool-content">
                            <label for="Cart-note" class="tf-mini-cart-tool-text">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18"
                                        viewBox="0 0 16 18" fill="currentColor">
                                        <path
                                            d="M5.12187 16.4582H2.78952C2.02045 16.4582 1.39476 15.8325 1.39476 15.0634V2.78952C1.39476 2.02045 2.02045 1.39476 2.78952 1.39476H11.3634C12.1325 1.39476 12.7582 2.02045 12.7582 2.78952V7.07841C12.7582 7.46357 13.0704 7.77579 13.4556 7.77579C13.8407 7.77579 14.1529 7.46357 14.1529 7.07841V2.78952C14.1529 1.25138 12.9016 0 11.3634 0H2.78952C1.25138 0 0 1.25138 0 2.78952V15.0634C0 16.6015 1.25138 17.8529 2.78952 17.8529H5.12187C5.50703 17.8529 5.81925 17.5407 5.81925 17.1555C5.81925 16.7704 5.50703 16.4582 5.12187 16.4582Z">
                                        </path>
                                        <path
                                            d="M15.3882 10.0971C14.5724 9.28136 13.2452 9.28132 12.43 10.0965L8.60127 13.9168C8.51997 13.9979 8.45997 14.0979 8.42658 14.2078L7.59276 16.9528C7.55646 17.0723 7.55292 17.1993 7.58249 17.3207C7.61206 17.442 7.67367 17.5531 7.76087 17.6425C7.84807 17.7319 7.95768 17.7962 8.07823 17.8288C8.19879 17.8613 8.32587 17.8609 8.44621 17.8276L11.261 17.0479C11.3769 17.0158 11.4824 16.9543 11.5675 16.8694L15.3882 13.0559C16.2039 12.2401 16.2039 10.9129 15.3882 10.0971ZM10.712 15.7527L9.29586 16.145L9.71028 14.7806L12.2937 12.2029L13.2801 13.1893L10.712 15.7527ZM14.4025 12.0692L14.2673 12.204L13.2811 11.2178L13.4157 11.0834C13.6876 10.8115 14.1301 10.8115 14.402 11.0834C14.6739 11.3553 14.6739 11.7977 14.4025 12.0692Z">
                                        </path>
                                    </svg>
                                </div>
                                <span>Add Order Note</span>
                            </label>
                            <textarea name="note" id="Cart-note" placeholder="How can we help you?"></textarea>
                            <div class="tf-cart-tool-btns justify-content-center">
                                <div
                                    class="tf-mini-cart-tool-primary text-center w-100 fw-6 tf-mini-cart-tool-close">
                                    Close</div>
                            </div>
                        </div>
                    </div>
                    <div class="tf-mini-cart-tool-openable add-gift">
                        <div class="overplay tf-mini-cart-tool-close"></div>
                        <form class="tf-product-form-addgift">
                            <div class="tf-mini-cart-tool-content">
                                <div class="tf-mini-cart-tool-text">
                                    <div class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="currentColor">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M4.65957 3.64545C4.65957 0.73868 7.89921 -0.995558 10.3176 0.617949L11.9997 1.74021L13.6818 0.617949C16.1001 -0.995558 19.3398 0.73868 19.3398 3.64545V4.32992H20.4286C21.9498 4.32992 23.1829 5.56311 23.1829 7.08416V9.10087C23.1829 9.61861 22.7632 10.0383 22.2454 10.0383H21.8528V20.2502C21.8528 20.254 21.8527 20.2577 21.8527 20.2614C21.8467 22.3272 20.1702 24 18.103 24H5.89634C3.82541 24 2.14658 22.3212 2.14658 20.2502V10.0384H1.75384C1.23611 10.0384 0.816406 9.61865 0.816406 9.10092V7.08421C0.816406 5.56304 2.04953 4.32992 3.57069 4.32992H4.65957V3.64545ZM6.53445 4.32992H11.0622V3.36863L9.27702 2.17757C8.10519 1.39573 6.53445 2.2357 6.53445 3.64545V4.32992ZM12.9371 3.36863V4.32992H17.4649V3.64545C17.4649 2.2357 15.8942 1.39573 14.7223 2.17756L12.9371 3.36863ZM3.57069 6.2048C3.08499 6.2048 2.69128 6.59851 2.69128 7.08421V8.16348H8.31067L8.3107 6.2048H3.57069ZM8.31071 10.0384V18.5741C8.31071 18.9075 8.48779 19.2158 8.77577 19.3838C9.06376 19.5518 9.4193 19.5542 9.70953 19.3901L11.9997 18.0953L14.2898 19.3901C14.58 19.5542 14.9356 19.5518 15.2236 19.3838C15.5115 19.2158 15.6886 18.9075 15.6886 18.5741V10.0383H19.9779V20.2137C19.9778 20.2169 19.9778 20.2201 19.9778 20.2233V20.2502C19.9778 21.2857 19.1384 22.1251 18.103 22.1251H5.89634C4.86088 22.1251 4.02146 21.2857 4.02146 20.2502V10.0384H8.31071ZM21.308 8.16344V7.08416C21.308 6.59854 20.9143 6.2048 20.4286 6.2048H15.6886V8.16344H21.308ZM13.8138 6.2048H10.1856V16.9672L11.5383 16.2024C11.8246 16.0405 12.1748 16.0405 12.461 16.2024L13.8138 16.9672V6.2048Z">
                                            </path>
                                        </svg>
                                    </div>
                                    <div class="tf-gift-wrap-infos">
                                        <p>Do you want a gift wrap?</p>
                                        Only
                                        <span class="price fw-6">$5.00</span>
                                    </div>
                                </div>
                                <div class="tf-cart-tool-btns">
                                    <button type="submit"
                                        class="tf-btn fw-6 w-100 justify-content-center btn-fill animate-hover-btn radius-3"><span>Add
                                            a gift wrap</span></button>
                                    <div
                                        class="tf-mini-cart-tool-primary text-center w-100 fw-6 tf-mini-cart-tool-close">
                                        Cancel</div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="tf-mini-cart-tool-openable estimate-shipping">
                        <div class="overplay tf-mini-cart-tool-close"></div>
                        <div class="tf-mini-cart-tool-content">
                            <div class="tf-mini-cart-tool-text">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15"
                                        viewBox="0 0 21 15" fill="currentColor">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M0.441406 1.13155C0.441406 0.782753 0.724159 0.5 1.07295 0.5H12.4408C12.7896 0.5 13.0724 0.782753 13.0724 1.13155V2.91575H16.7859C18.8157 2.91575 20.5581 4.43473 20.5581 6.42296V11.8878C20.5581 12.2366 20.2753 12.5193 19.9265 12.5193H18.7542C18.4967 13.6534 17.4823 14.5 16.2703 14.5C15.0582 14.5 14.0439 13.6534 13.7864 12.5193H7.20445C6.94692 13.6534 5.93259 14.5 4.72054 14.5C3.50849 14.5 2.49417 13.6534 2.23664 12.5193H1.07295C0.724159 12.5193 0.441406 12.2366 0.441406 11.8878V1.13155ZM2.26988 11.2562C2.57292 10.1881 3.55537 9.40578 4.72054 9.40578C5.88572 9.40578 6.86817 10.1881 7.17121 11.2562H11.8093V1.76309H1.7045V11.2562H2.26988ZM13.0724 4.17884V6.68916H19.295V6.42296C19.295 5.2348 18.2252 4.17884 16.7859 4.17884H13.0724ZM19.295 7.95226H13.0724V11.2562H13.8196C14.1227 10.1881 15.1051 9.40578 16.2703 9.40578C17.4355 9.40578 18.4179 10.1881 18.7209 11.2562H19.295V7.95226ZM4.72054 10.6689C4.0114 10.6689 3.43652 11.2437 3.43652 11.9529C3.43652 12.662 4.0114 13.2369 4.72054 13.2369C5.42969 13.2369 6.00456 12.662 6.00456 11.9529C6.00456 11.2437 5.42969 10.6689 4.72054 10.6689ZM16.2703 10.6689C15.5611 10.6689 14.9863 11.2437 14.9863 11.9529C14.9863 12.662 15.5611 13.2369 16.2703 13.2369C16.9794 13.2369 17.5543 12.662 17.5543 11.9529C17.5543 11.2437 16.9794 10.6689 16.2703 10.6689Z">
                                        </path>
                                    </svg>
                                </div>
                                <span class="fw-6">Estimate Shipping</span>
                            </div>
                            <div class="field">
                                <p>Country</p>
                                <select class="tf-select w-100" id="ShippingCountry_CartDrawer-Form"
                                    name="address[country]" data-default="">
                                    <option value="---" data-provinces="[]">---</option>
                                    <option value="Australia"
                                        data-provinces="[['Australian Capital Territory','Australian Capital Territory'],['New South Wales','New South Wales'],['Northern Territory','Northern Territory'],['Queensland','Queensland'],['South Australia','South Australia'],['Tasmania','Tasmania'],['Victoria','Victoria'],['Western Australia','Western Australia']]">
                                        Australia</option>
                                    <option value="Austria" data-provinces="[]">Austria</option>
                                    <option value="Belgium" data-provinces="[]">Belgium</option>
                                    <option value="Canada"
                                        data-provinces="[['Alberta','Alberta'],['British Columbia','British Columbia'],['Manitoba','Manitoba'],['New Brunswick','New Brunswick'],['Newfoundland and Labrador','Newfoundland and Labrador'],['Northwest Territories','Northwest Territories'],['Nova Scotia','Nova Scotia'],['Nunavut','Nunavut'],['Ontario','Ontario'],['Prince Edward Island','Prince Edward Island'],['Quebec','Quebec'],['Saskatchewan','Saskatchewan'],['Yukon','Yukon']]">
                                        Canada</option>
                                    <option value="Czech Republic" data-provinces="[]">Czechia</option>
                                    <option value="Denmark" data-provinces="[]">Denmark</option>
                                    <option value="Finland" data-provinces="[]">Finland</option>
                                    <option value="France" data-provinces="[]">France</option>
                                    <option value="Germany" data-provinces="[]">Germany</option>
                                    <option value="Hong Kong"
                                        data-provinces="[['Hong Kong Island','Hong Kong Island'],['Kowloon','Kowloon'],['New Territories','New Territories']]">
                                        Hong Kong SAR</option>
                                    <option value="Ireland"
                                        data-provinces="[['Carlow','Carlow'],['Cavan','Cavan'],['Clare','Clare'],['Cork','Cork'],['Donegal','Donegal'],['Dublin','Dublin'],['Galway','Galway'],['Kerry','Kerry'],['Kildare','Kildare'],['Kilkenny','Kilkenny'],['Laois','Laois'],['Leitrim','Leitrim'],['Limerick','Limerick'],['Longford','Longford'],['Louth','Louth'],['Mayo','Mayo'],['Meath','Meath'],['Monaghan','Monaghan'],['Offaly','Offaly'],['Roscommon','Roscommon'],['Sligo','Sligo'],['Tipperary','Tipperary'],['Waterford','Waterford'],['Westmeath','Westmeath'],['Wexford','Wexford'],['Wicklow','Wicklow']]">
                                        Ireland</option>
                                    <option value="Israel" data-provinces="[]">Israel</option>
                                    <option value="Italy"
                                        data-provinces="[['Agrigento','Agrigento'],['Alessandria','Alessandria'],['Ancona','Ancona'],['Aosta','Aosta Valley'],['Arezzo','Arezzo'],['Ascoli Piceno','Ascoli Piceno'],['Asti','Asti'],['Avellino','Avellino'],['Bari','Bari'],['Barletta-Andria-Trani','Barletta-Andria-Trani'],['Belluno','Belluno'],['Benevento','Benevento'],['Bergamo','Bergamo'],['Biella','Biella'],['Bologna','Bologna'],['Bolzano','South Tyrol'],['Brescia','Brescia'],['Brindisi','Brindisi'],['Cagliari','Cagliari'],['Caltanissetta','Caltanissetta'],['Campobasso','Campobasso'],['Carbonia-Iglesias','Carbonia-Iglesias'],['Caserta','Caserta'],['Catania','Catania'],['Catanzaro','Catanzaro'],['Chieti','Chieti'],['Como','Como'],['Cosenza','Cosenza'],['Cremona','Cremona'],['Crotone','Crotone'],['Cuneo','Cuneo'],['Enna','Enna'],['Fermo','Fermo'],['Ferrara','Ferrara'],['Firenze','Florence'],['Foggia','Foggia'],['Forlì-Cesena','Forlì-Cesena'],['Frosinone','Frosinone'],['Genova','Genoa'],['Gorizia','Gorizia'],['Grosseto','Grosseto'],['Imperia','Imperia'],['Isernia','Isernia'],['L'Aquila','L’Aquila'],['La Spezia','La Spezia'],['Latina','Latina'],['Lecce','Lecce'],['Lecco','Lecco'],['Livorno','Livorno'],['Lodi','Lodi'],['Lucca','Lucca'],['Macerata','Macerata'],['Mantova','Mantua'],['Massa-Carrara','Massa and Carrara'],['Matera','Matera'],['Medio Campidano','Medio Campidano'],['Messina','Messina'],['Milano','Milan'],['Modena','Modena'],['Monza e Brianza','Monza and Brianza'],['Napoli','Naples'],['Novara','Novara'],['Nuoro','Nuoro'],['Ogliastra','Ogliastra'],['Olbia-Tempio','Olbia-Tempio'],['Oristano','Oristano'],['Padova','Padua'],['Palermo','Palermo'],['Parma','Parma'],['Pavia','Pavia'],['Perugia','Perugia'],['Pesaro e Urbino','Pesaro and Urbino'],['Pescara','Pescara'],['Piacenza','Piacenza'],['Pisa','Pisa'],['Pistoia','Pistoia'],['Pordenone','Pordenone'],['Potenza','Potenza'],['Prato','Prato'],['Ragusa','Ragusa'],['Ravenna','Ravenna'],['Reggio Calabria','Reggio Calabria'],['Reggio Emilia','Reggio Emilia'],['Rieti','Rieti'],['Rimini','Rimini'],['Roma','Rome'],['Rovigo','Rovigo'],['Salerno','Salerno'],['Sassari','Sassari'],['Savona','Savona'],['Siena','Siena'],['Siracusa','Syracuse'],['Sondrio','Sondrio'],['Taranto','Taranto'],['Teramo','Teramo'],['Terni','Terni'],['Torino','Turin'],['Trapani','Trapani'],['Trento','Trentino'],['Treviso','Treviso'],['Trieste','Trieste'],['Udine','Udine'],['Varese','Varese'],['Venezia','Venice'],['Verbano-Cusio-Ossola','Verbano-Cusio-Ossola'],['Vercelli','Vercelli'],['Verona','Verona'],['Vibo Valentia','Vibo Valentia'],['Vicenza','Vicenza'],['Viterbo','Viterbo']]">
                                        Italy</option>
                                    <option value="Japan"
                                        data-provinces="[['Aichi','Aichi'],['Akita','Akita'],['Aomori','Aomori'],['Chiba','Chiba'],['Ehime','Ehime'],['Fukui','Fukui'],['Fukuoka','Fukuoka'],['Fukushima','Fukushima'],['Gifu','Gifu'],['Gunma','Gunma'],['Hiroshima','Hiroshima'],['Hokkaidō','Hokkaido'],['Hyōgo','Hyogo'],['Ibaraki','Ibaraki'],['Ishikawa','Ishikawa'],['Iwate','Iwate'],['Kagawa','Kagawa'],['Kagoshima','Kagoshima'],['Kanagawa','Kanagawa'],['Kumamoto','Kumamoto'],['Kyōto','Kyoto'],['Kōchi','Kochi'],['Mie','Mie'],['Miyagi','Miyagi'],['Miyazaki','Miyazaki'],['Nagano','Nagano'],['Nagasaki','Nagasaki'],['Nara','Nara'],['Niigata','Niigata'],['Okayama','Okayama'],['Okinawa','Okinawa'],['Saga','Saga'],['Saitama','Saitama'],['Shiga','Shiga'],['Shimane','Shimane'],['Shizuoka','Shizuoka'],['Tochigi','Tochigi'],['Tokushima','Tokushima'],['Tottori','Tottori'],['Toyama','Toyama'],['Tōkyō','Tokyo'],['Wakayama','Wakayama'],['Yamagata','Yamagata'],['Yamaguchi','Yamaguchi'],['Yamanashi','Yamanashi'],['Ōita','Oita'],['Ōsaka','Osaka']]">
                                        Japan</option>
                                    <option value="Malaysia"
                                        data-provinces="[['Johor','Johor'],['Kedah','Kedah'],['Kelantan','Kelantan'],['Kuala Lumpur','Kuala Lumpur'],['Labuan','Labuan'],['Melaka','Malacca'],['Negeri Sembilan','Negeri Sembilan'],['Pahang','Pahang'],['Penang','Penang'],['Perak','Perak'],['Perlis','Perlis'],['Putrajaya','Putrajaya'],['Sabah','Sabah'],['Sarawak','Sarawak'],['Selangor','Selangor'],['Terengganu','Terengganu']]">
                                        Malaysia</option>
                                    <option value="Netherlands" data-provinces="[]">Netherlands</option>
                                    <option value="New Zealand"
                                        data-provinces="[['Auckland','Auckland'],['Bay of Plenty','Bay of Plenty'],['Canterbury','Canterbury'],['Chatham Islands','Chatham Islands'],['Gisborne','Gisborne'],['Hawke's Bay','Hawke’s Bay'],['Manawatu-Wanganui','Manawatū-Whanganui'],['Marlborough','Marlborough'],['Nelson','Nelson'],['Northland','Northland'],['Otago','Otago'],['Southland','Southland'],['Taranaki','Taranaki'],['Tasman','Tasman'],['Waikato','Waikato'],['Wellington','Wellington'],['West Coast','West Coast']]">
                                        New Zealand</option>
                                    <option value="Norway" data-provinces="[]">Norway</option>
                                    <option value="Poland" data-provinces="[]">Poland</option>
                                    <option value="Portugal"
                                        data-provinces="[['Aveiro','Aveiro'],['Açores','Azores'],['Beja','Beja'],['Braga','Braga'],['Bragança','Bragança'],['Castelo Branco','Castelo Branco'],['Coimbra','Coimbra'],['Faro','Faro'],['Guarda','Guarda'],['Leiria','Leiria'],['Lisboa','Lisbon'],['Madeira','Madeira'],['Portalegre','Portalegre'],['Porto','Porto'],['Santarém','Santarém'],['Setúbal','Setúbal'],['Viana do Castelo','Viana do Castelo'],['Vila Real','Vila Real'],['Viseu','Viseu'],['Évora','Évora']]">
                                        Portugal</option>
                                    <option value="Singapore" data-provinces="[]">Singapore</option>
                                    <option value="South Korea"
                                        data-provinces="[['Busan','Busan'],['Chungbuk','North Chungcheong'],['Chungnam','South Chungcheong'],['Daegu','Daegu'],['Daejeon','Daejeon'],['Gangwon','Gangwon'],['Gwangju','Gwangju City'],['Gyeongbuk','North Gyeongsang'],['Gyeonggi','Gyeonggi'],['Gyeongnam','South Gyeongsang'],['Incheon','Incheon'],['Jeju','Jeju'],['Jeonbuk','North Jeolla'],['Jeonnam','South Jeolla'],['Sejong','Sejong'],['Seoul','Seoul'],['Ulsan','Ulsan']]">
                                        South Korea</option>
                                    <option value="Spain"
                                        data-provinces="[['A Coruña','A Coruña'],['Albacete','Albacete'],['Alicante','Alicante'],['Almería','Almería'],['Asturias','Asturias Province'],['Badajoz','Badajoz'],['Balears','Balears Province'],['Barcelona','Barcelona'],['Burgos','Burgos'],['Cantabria','Cantabria Province'],['Castellón','Castellón'],['Ceuta','Ceuta'],['Ciudad Real','Ciudad Real'],['Cuenca','Cuenca'],['Cáceres','Cáceres'],['Cádiz','Cádiz'],['Córdoba','Córdoba'],['Girona','Girona'],['Granada','Granada'],['Guadalajara','Guadalajara'],['Guipúzcoa','Gipuzkoa'],['Huelva','Huelva'],['Huesca','Huesca'],['Jaén','Jaén'],['La Rioja','La Rioja Province'],['Las Palmas','Las Palmas'],['León','León'],['Lleida','Lleida'],['Lugo','Lugo'],['Madrid','Madrid Province'],['Melilla','Melilla'],['Murcia','Murcia'],['Málaga','Málaga'],['Navarra','Navarra'],['Ourense','Ourense'],['Palencia','Palencia'],['Pontevedra','Pontevedra'],['Salamanca','Salamanca'],['Santa Cruz de Tenerife','Santa Cruz de Tenerife'],['Segovia','Segovia'],['Sevilla','Seville'],['Soria','Soria'],['Tarragona','Tarragona'],['Teruel','Teruel'],['Toledo','Toledo'],['Valencia','Valencia'],['Valladolid','Valladolid'],['Vizcaya','Biscay'],['Zamora','Zamora'],['Zaragoza','Zaragoza'],['Álava','Álava'],['Ávila','Ávila']]">
                                        Spain</option>
                                    <option value="Sweden" data-provinces="[]">Sweden</option>
                                    <option value="Switzerland" data-provinces="[]">Switzerland</option>
                                    <option value="United Arab Emirates"
                                        data-provinces="[['Abu Dhabi','Abu Dhabi'],['Ajman','Ajman'],['Dubai','Dubai'],['Fujairah','Fujairah'],['Ras al-Khaimah','Ras al-Khaimah'],['Sharjah','Sharjah'],['Umm al-Quwain','Umm al-Quwain']]">
                                        United Arab Emirates</option>
                                    <option value="United Kingdom"
                                        data-provinces="[['British Forces','British Forces'],['England','England'],['Northern Ireland','Northern Ireland'],['Scotland','Scotland'],['Wales','Wales']]">
                                        United Kingdom</option>
                                    <option value="United States"
                                        data-provinces="[['Alabama','Alabama'],['Alaska','Alaska'],['American Samoa','American Samoa'],['Arizona','Arizona'],['Arkansas','Arkansas'],['Armed Forces Americas','Armed Forces Americas'],['Armed Forces Europe','Armed Forces Europe'],['Armed Forces Pacific','Armed Forces Pacific'],['California','California'],['Colorado','Colorado'],['Connecticut','Connecticut'],['Delaware','Delaware'],['District of Columbia','Washington DC'],['Federated States of Micronesia','Micronesia'],['Florida','Florida'],['Georgia','Georgia'],['Guam','Guam'],['Hawaii','Hawaii'],['Idaho','Idaho'],['Illinois','Illinois'],['Indiana','Indiana'],['Iowa','Iowa'],['Kansas','Kansas'],['Kentucky','Kentucky'],['Louisiana','Louisiana'],['Maine','Maine'],['Marshall Islands','Marshall Islands'],['Maryland','Maryland'],['Massachusetts','Massachusetts'],['Michigan','Michigan'],['Minnesota','Minnesota'],['Mississippi','Mississippi'],['Missouri','Missouri'],['Montana','Montana'],['Nebraska','Nebraska'],['Nevada','Nevada'],['New Hampshire','New Hampshire'],['New Jersey','New Jersey'],['New Mexico','New Mexico'],['New York','New York'],['North Carolina','North Carolina'],['North Dakota','North Dakota'],['Northern Mariana Islands','Northern Mariana Islands'],['Ohio','Ohio'],['Oklahoma','Oklahoma'],['Oregon','Oregon'],['Palau','Palau'],['Pennsylvania','Pennsylvania'],['Puerto Rico','Puerto Rico'],['Rhode Island','Rhode Island'],['South Carolina','South Carolina'],['South Dakota','South Dakota'],['Tennessee','Tennessee'],['Texas','Texas'],['Utah','Utah'],['Vermont','Vermont'],['Virgin Islands','U.S. Virgin Islands'],['Virginia','Virginia'],['Washington','Washington'],['West Virginia','West Virginia'],['Wisconsin','Wisconsin'],['Wyoming','Wyoming']]">
                                        United States</option>
                                    <option value="Vietnam" data-provinces="[]">Vietnam</option>
                                </select>
                            </div>
                            <div class="field">
                                <p>Zip code</p>
                                <input type="text" name="text" placeholder="">
                            </div>
                            <div class="tf-cart-tool-btns">
                                <a href="#"
                                    class="tf-btn fw-6 justify-content-center btn-fill w-100 animate-hover-btn radius-3"><span>Estimate</span></a>
                                <div
                                    class="tf-mini-cart-tool-primary text-center fw-6 w-100 tf-mini-cart-tool-close">
                                    Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="offcanvas offcanvas-end canvas-search" id="canvasSearch">
  <div class="canvas-wrapper">
      <header class="tf-search-head">
          <div class="title fw-5">
            Rechercher sur notre site
              <div class="close">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
              </div>
          </div>
          <div class="tf-search-sticky">
              <form class="tf-mini-search-frm">
                  <fieldset class="text">
                      <input type="text" placeholder="Recherche" [(ngModel)]="searchQuery"
                      (input)="performInstantSearch()" class="" name="text" tabindex="0" value=""
                          aria-required="true" required="">
                  </fieldset>
                  <button class="" type="submit"><i class="icon-search"></i></button>
              </form>
          </div>
      </header>
      <div class="canvas-body p-0">
          <div class="tf-search-content">
              <div class="tf-cart-hide-has-results">

                  <div class="tf-col-content">
                      <div class="tf-search-content-title fw-5"> Résultats pour "{{ searchQuery }}" ({{ articles.length }} trouvé{{ articles.length > 1 ? 's' : '' }}) </div>

            <div *ngIf="articles.length === 0" class="p-3 text-muted">
              Aucun article trouvé.
            </div>

            <div class="tf-search-hidden-inner">
              <div class="tf-loop-item" *ngFor="let article of articles" (click)="goToProduct(article.id, article.libelle)">
                <div class="image">
                  <a href="javascript:void(0)">
                    <img [src]="article.images[0]?.data" alt="">
                  </a>
                </div>
                <div class="content">
                  <a href="javascript:void(0)">{{ article.libelle }}</a>
                  <div class="tf-product-info-price">
                    <div class="price fw-6">{{ article.prix_ttc | number:'1.3-3' }} DT</div>
                  </div>
                </div>
              </div>
            </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

  <div class="modal fade modalDemo" id="modalDemo">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="header">
                <h5 class="demo-title">Ultimate HTML Theme</h5>
                <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
            </div>
            <div class="mega-menu">
                <div class="row-demo">
                    <div class="demo-item">
                        <a href="index.html">
                            <div class="demo-image position-relative">
                                <img class="lazyload" data-src="assets/images/demo/home-01.jpg"
                                    src="assets/images/demo/home-01.jpg" alt="home-01">
                                <div class="demo-label">
                                    <span class="demo-new">New</span>
                                    <span>Trend</span>
                                </div>
                            </div>
                            <span class="demo-name">Home Fashion 01</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-multi-brand.html">
                            <div class="demo-image position-relative">
                                <img class="lazyload" data-src="assets/images/demo/home-multi-brand.jpg"
                                    src="assets/images/demo/home-multi-brand.jpg" alt="home-multi-brand">
                                <div class="demo-label">
                                    <span class="demo-new">New</span>
                                    <span class="demo-hot">Hot</span>
                                </div>
                            </div>
                            <span class="demo-name">Home Multi Brand</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-02.html">
                            <div class="demo-image position-relative">
                                <img class="lazyload" data-src="assets/images/demo/home-02.jpg"
                                    src="assets/images/demo/home-02.jpg" alt="home-02">
                                <div class="demo-label">
                                    <span class="demo-hot">Hot</span>
                                </div>
                            </div>
                            <span class="demo-name">Home Fashion 02</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-03.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-03.jpg"
                                    src="assets/images/demo/home-03.jpg" alt="home-03">
                            </div>
                            <span class="demo-name">Home Fashion 03</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-04.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-04.jpg"
                                    src="assets/images/demo/home-04.jpg" alt="home-04">
                            </div>
                            <span class="demo-name">Home Fashion 04</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-05.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-05.jpg"
                                    src="assets/images/demo/home-05.jpg" alt="home-05">
                            </div>
                            <span class="demo-name">Home Fashion 05</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-06.html">
                            <div class="demo-image position-relative">
                                <img class="lazyload" data-src="assets/images/demo/home-06.jpg"
                                    src="assets/images/demo/home-06.jpg" alt="home-06">
                            </div>
                            <span class="demo-name">Home Fashion 06</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-drinkwear.html">
                            <div class="demo-image position-relative">
                                <img class="lazyload" data-src="assets/images/demo/home-drinkwear.png"
                                    src="assets/images/demo/home-drinkwear.png" alt="home-drinkwear">
                                <div class="demo-label">
                                    <span class="demo-new">New</span>
                                </div>
                            </div>
                            <span class="demo-name">Home Drinkwear</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-supplement.html">
                            <div class="demo-image position-relative">
                                <img class="lazyload" data-src="assets/images/demo/home-supplement.png"
                                    src="assets/images/demo/home-supplement.png" alt="home-supplement">
                                <div class="demo-label">
                                    <span class="demo-new">New</span>
                                </div>
                            </div>
                            <span class="demo-name">Home Supplement</span>
                        </a>
                    </div>

                    <div class="demo-item">
                        <a href="home-personalized-pod.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-personalized-pod.jpg"
                                    src="assets/images/demo/home-personalized-pod.jpg" alt="home-personalized-pod">
                            </div>
                            <span class="demo-name">Home Personalized Pod</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-pickleball.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-pickleball.png"
                                    src="assets/images/demo/home-pickleball.png" alt="home-pickleball">
                            </div>
                            <span class="demo-name">Home Pickleball</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-ceramic.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-ceramic.png"
                                    src="assets/images/demo/home-ceramic.png" alt="home-ceramic">
                            </div>
                            <span class="demo-name">Home Ceramic</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-food.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-food.png"
                                    src="assets/images/demo/home-food.png" alt="home-food">
                            </div>
                            <span class="demo-name">Home Food</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-camp-and-hike.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-camp-and-hike.png"
                                    src="assets/images/demo/home-camp-and-hike.png" alt="home-camp-and-hike">
                            </div>
                            <span class="demo-name">Home Camp And Hike</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-07.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-07.jpg"
                                    src="assets/images/demo/home-07.jpg" alt="home-07">
                            </div>
                            <span class="demo-name">Home Fashion 07</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-08.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-08.jpg"
                                    src="assets/images/demo/home-08.jpg" alt="home-08">
                            </div>
                            <span class="demo-name">Home Fashion 08</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-skincare.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-skincare.jpg"
                                    src="assets/images/demo/home-skincare.jpg" alt="home-skincare">
                            </div>
                            <span class="demo-name">Home Skincare</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-headphone.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-headphone.jpg"
                                    src="assets/images/demo/home-headphone.jpg" alt="home-headphone">
                            </div>
                            <span class="demo-name">Home Headphone</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-giftcard.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-giftcard.jpg"
                                    src="assets/images/demo/home-giftcard.jpg" alt="home-gift-card">
                            </div>
                            <span class="demo-name">Home Gift Card</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-furniture.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-furniture.jpg"
                                    src="assets/images/demo/home-furniture.jpg" alt="home-furniture">
                            </div>
                            <span class="demo-name">Home Furniture</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-furniture-02.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-furniture2.jpg"
                                    src="assets/images/demo/home-furniture2.jpg" alt="home-furniture-2">
                            </div>
                            <span class="demo-name">Home Furniture 2</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-skateboard.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-skateboard.jpg"
                                    src="assets/images/demo/home-skateboard.jpg" alt="home-skateboard">
                            </div>
                            <span class="demo-name">Home Skateboard</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-stroller.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-stroller.jpg"
                                    src="assets/images/demo/home-stroller.jpg" alt="home-stroller">
                            </div>
                            <span class="demo-name">Home Stroller</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-decor.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-decor.jpg"
                                    src="assets/images/demo/home-decor.jpg" alt="home-decor">
                            </div>
                            <span class="demo-name">Home Decor</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-electronic.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-electronic.jpg"
                                    src="assets/images/demo/home-electronic.jpg" alt="home-electronic">
                            </div>
                            <span class="demo-name">Home Electronic</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-setup-gear.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-setup-gear.jpg"
                                    src="assets/images/demo/home-setup-gear.jpg" alt="home-setup-gear">
                            </div>
                            <span class="demo-name">Home Setup Gear</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-dog-accessories.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-dog-accessories.jpg"
                                    src="assets/images/demo/home-dog-accessories.jpg" alt="home-dog-accessories">
                            </div>
                            <span class="demo-name">Home Dog Accessories</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-kitchen-wear.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-kitchen.jpg"
                                    src="assets/images/demo/home-kitchen.jpg" alt="home-kitchen-wear">
                            </div>
                            <span class="demo-name">Home Kitchen Wear</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-phonecase.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-phonecase.jpg"
                                    src="assets/images/demo/home-phonecase.jpg" alt="home-phonecase">
                            </div>
                            <span class="demo-name">Home Phonecase</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-paddle-boards.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home_paddle_board.jpg"
                                    src="assets/images/demo/home_paddle_board.jpg" alt="home-paddle_board">
                            </div>
                            <span class="demo-name">Home Paddle Boards</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-glasses.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-glasses.jpg"
                                    src="assets/images/demo/home-glasses.jpg" alt="home-glasses">
                            </div>
                            <span class="demo-name">Home Glasses</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-pod-store.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-pod-store.jpg"
                                    src="assets/images/demo/home-pod-store.jpg" alt="home-pod-store">
                            </div>
                            <span class="demo-name">Home POD Store</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-activewear.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-activewear.jpg"
                                    src="assets/images/demo/home-activewear.jpg" alt="home-activewear">
                            </div>
                            <span class="demo-name">Activewear</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-handbag.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-handbag.jpg"
                                    src="assets/images/demo/home-handbag.jpg" alt="home-handbag">
                            </div>
                            <span class="demo-name">Home Handbag</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-tee.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-tee.jpg"
                                    src="assets/images/demo/home-tee.jpg" alt="home-tee">
                            </div>
                            <span class="demo-name">Home Tee</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-sock.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-socks.jpg"
                                    src="assets/images/demo/home-socks.jpg" alt="home-sock">
                            </div>
                            <span class="demo-name">Home Sock</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-jewerly.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-jewelry.jpg"
                                    src="assets/images/demo/home-jewelry.jpg" alt="home-jewelry">
                            </div>
                            <span class="demo-name">Home Jewelry</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-sneaker.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-sneaker.jpg"
                                    src="assets/images/demo/home-sneaker.jpg" alt="home-sneaker">
                            </div>
                            <span class="demo-name">Home Sneaker</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-accessories.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-accessories.jpg"
                                    src="assets/images/demo/home-accessories.jpg" alt="home-accessories">
                            </div>
                            <span class="demo-name">Home Accessories</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-grocery.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-gocery.jpg"
                                    src="assets/images/demo/home-gocery.jpg" alt="home-grocery">
                            </div>
                            <span class="demo-name">Home Grocery</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-baby.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-baby.jpg"
                                    src="assets/images/demo/home-baby.jpg" alt="home-baby">
                            </div>
                            <span class="demo-name">Home Baby</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-cosmetic.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-cosmetic.png"
                                    src="assets/images/demo/home-cosmetic.png" alt="home-cosmetic">
                            </div>
                            <span class="demo-name">Home Cosmetic</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-plant.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-plant.png"
                                    src="assets/images/demo/home-plant.png" alt="home-plant">
                            </div>
                            <span class="demo-name">Home Plant</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-swimwear.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-swimwear.png"
                                    src="assets/images/demo/home-swimwear.png" alt="home-swimwear">
                            </div>
                            <span class="demo-name">Home Swimwear</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-electric-bike.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-electric-bike.png"
                                    src="assets/images/demo/home-electric-bike.png" alt="home-electric-bike">
                            </div>
                            <span class="demo-name">Home Electric Bike</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-footwear.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-footwear.jpg"
                                    src="assets/images/demo/home-footwear.jpg" alt="home-footwear">
                            </div>
                            <span class="demo-name">Home Footwear</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-book-store.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-bookstore.png"
                                    src="assets/images/demo/home-bookstore.png" alt="home-bookstore">
                            </div>
                            <span class="demo-name">Home Bookstore</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-gaming-accessories.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-gaming-accessories.png"
                                    src="assets/images/demo/home-gaming-accessories.png" alt="home-gaming-accessories">
                            </div>
                            <span class="demo-name">Home Gaming Accessories</span>
                        </a>
                    </div>
                    <div class="demo-item">
                        <a href="home-parallax.html">
                            <div class="demo-image">
                                <img class="lazyload" data-src="assets/images/demo/home-skincare.jpg"
                                    src="assets/images/demo/home-skincare.jpg" alt="home-skincare">
                            </div>
                            <span class="demo-name">Home Parallax</span>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
  </div>
  <div class="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
    <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
    <div class="mb-canvas-content">
        <div class="mb-body">
            <ul class="nav-ul-mb" id="wrapper-menu-navigation">
                <li class="nav-mb-item">
                    <a href="#dropdown-menu-one" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="dropdown-menu-one">
                        <span>Accueil</span>

                    </a>


                </li>
                <li class="nav-mb-item">
                    <a href="#dropdown-menu-two" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="dropdown-menu-two">
                        <span>Boutique</span>
                        <span class="btn-open-sub"></span>
                    </a>
                    <div id="dropdown-menu-two" class="collapse">
                        <ul class="sub-nav-menu" id="sub-menu-navigation">
                           <li *ngFor="let category of listCategory; let i = index">
  <a class="sub-nav-link collapsed" data-bs-toggle="collapse"
     [attr.aria-controls]="'sub-shop-' + i"
     aria-expanded="false"
     [attr.data-bs-target]="'#sub-shop-' + i">
    <span (click)="navigateToCategory(category)">{{ category.libelle }}</span>
    <span *ngIf="category.sous_categories?.length > 0" class="btn-open-sub"></span>
  </a>
  <div [id]="'sub-shop-' + i" class="collapse">
    <ul class="sub-nav-menu sub-menu-level-2">
      <li *ngFor="let sub of category.sous_categories">
        <a (click)="navigateToSubCategory(sub.id)" class="sub-nav-link">{{ sub.libelle }}</a>
      </li>
    </ul>
  </div>
</li>

                        </ul>
                    </div>
                </li>
                <li class="nav-mb-item">
                    <a href="/contact" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="dropdown-menu-three">
                        <span>Contact</span>

                    </a>

                </li>
                <li class="nav-mb-item">
                    <a  (click)="goToAccount($event)" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="dropdown-menu-four">
                        <span>Mon Compte</span>

                    </a>


                </li>

                <li class="nav-mb-item">
                    <a href="/checkout"
                        class="mb-menu-link">Commander</a>
                </li>
            </ul>
            <div class="mb-other-content">
                <div class="d-flex group-icon">
                    <a href="/wishlist" class="site-nav-icon"><i class="icon icon-heart"></i>Favoris</a>

                </div>
                <div class="mb-notice">
                    <a href="/contact" class="text-need">Besoin d'aide ?</a>
                </div>
                <ul class="mb-info">

                    <li>Email: <b>adorastoretn@gmail.com</b></li>
                    <li>Telephone: <b>+216 58955712</b></li>
                </ul>
            </div>
        </div>
        <div class="mb-bottom">
            <a  (click)="goToAccount($event)" class="site-nav-icon"><i class="icon icon-account"></i>Se Connecter</a>

        </div>
    </div>
  </div>
</div>

